import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class Email extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static EmailProperties: (
    | {
        property: keyof Email;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof Email;
        type: 'alias';
      }
    | {
        property: keyof Email;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'to', type: 'column', dataType: 'string' },
    { property: 'from', type: 'column', dataType: 'string' },
    { property: 'cc', type: 'column', dataType: 'string' },
    { property: 'bcc', type: 'column', dataType: 'string' },
    { property: 'subject', type: 'column', dataType: 'string' },
    { property: 'text', type: 'column', dataType: 'string' },
    { property: 'html', type: 'column', dataType: 'string' },
    { property: 'sent', type: 'column', dataType: 'boolean' },
    { property: 'unsendable', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    Email.EmailProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        Email.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        Email.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        Email.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(EmailObject: Partial<Email>) {
    super();

    Email.EmailProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = EmailObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  to?: string;
  from?: string;
  cc?: string;
  bcc?: string;
  subject?: string;
  text?: string;
  html?: string;
  sent?: boolean;
  unsendable?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
